import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall, AxiosPost } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchScheduledJobs() {
  try {
    const result = yield call(AxiosCall, `/admin/fetch_scheduled_jobs/`);
    yield put(actions.fetchScheduledJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchScheduledJobsFailure(e));
  }
}

function* fetchQueuedJobs() {
  try {
    const result = yield call(AxiosCall, `/admin/fetch_queued_jobs/`);
    yield put(actions.fetchQueuedJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchQueuedJobsFailure(e));
  }
}

function* fetchRunningJobs() {
  try {
    const result = yield call(AxiosCall, `/admin/fetch_running_jobs/`);
    yield put(actions.fetchRunningJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchRunningJobsFailure(e));
  }
}

function* fetchFinishedJobs(action) {
  try {
    const { limit } = action.payload;
    const result = yield call(AxiosCall, `/admin/fetch_finished_jobs/?limit=${limit}`);
    yield put(actions.fetchFinishedJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchFinishedJobsFailure(e));
  }
}

function* fetchFailedJobs(action) {
  try {
    const { limit } = action.payload;
    const result = yield call(AxiosCall, `/admin/fetch_failed_jobs/?limit=${limit}`);
    yield put(actions.fetchFailedJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchFailedJobsFailure(e));
  }
}

function* fetchStatistics() {
  try {
    const result = yield call(AxiosCall, `/admin/fetch_statistics/`);
    yield put(actions.fetchStatisticsSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchStatisticsFailure(e));
  }
}

function* fetchJobDetail(action) {
  try {
    const { job_id } = action.payload;
    const result = yield call(AxiosCall, `/admin/fetch_job_detail/?job_id=${job_id}`);
    yield put(actions.fetchJobDetailSuccess(result.data));
  } catch (e) {
    yield put(actions.fetchJobDetailFailure(e));
  }
}

function* removeScheduledJob(action) {
  try {
    const { job_id } = action.payload;
    const result = yield call(AxiosPost, `/admin/remove_scheduled_job/`, { job_id });

    if (result.data.response !== 'READING_UPDATED')
      throw new Error('error al cancelar el job');

    yield put(actions.removeScheduledJobSuccess(job_id));
  } catch (e) {
    yield put(actions.removeScheduledJobFailure(e.message));
  }
}

function* removeJob(action) {
  try {
    const { job_id } = action.payload;
    yield call(AxiosPost, `/admin/remove_job/`, { job_id });
    yield put(actions.removeJobSuccess(job_id));
  } catch (e) {
    yield put(actions.removeJobFailure(e.message));
  }
}

function* clearFinishedJobs(action) {
  try {
    const { older_than_hours } = action.payload;
    const result = yield call(AxiosPost, `/admin/clear_finished_jobs/`, { older_than_hours });
    yield put(actions.clearFinishedJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.clearFinishedJobsFailure(e.message));
  }
}

function* clearFailedJobs() {
  try {
    const result = yield call(AxiosPost, `/admin/clear_failed_jobs/`);
    yield put(actions.clearFailedJobsSuccess(result.data));
  } catch (e) {
    yield put(actions.clearFailedJobsFailure(e.message));
  }
}

export default function* adminSaga() {
  yield all([
    takeLatest(actions.FETCH_SCHEDULED_JOBS.REQUEST, fetchScheduledJobs),
    takeLatest(actions.FETCH_QUEUED_JOBS.REQUEST, fetchQueuedJobs),
    takeLatest(actions.FETCH_RUNNING_JOBS.REQUEST, fetchRunningJobs),
    takeLatest(actions.FETCH_FINISHED_JOBS.REQUEST, fetchFinishedJobs),
    takeLatest(actions.FETCH_FAILED_JOBS.REQUEST, fetchFailedJobs),
    takeLatest(actions.FETCH_STATISTICS.REQUEST, fetchStatistics),
    takeLatest(actions.FETCH_JOB_DETAIL.REQUEST, fetchJobDetail),
    takeLatest(actions.REMOVE_SCHEDULED_JOB.REQUEST, removeScheduledJob),
    takeLatest(actions.REMOVE_JOB.REQUEST, removeJob),
    takeLatest(actions.CLEAR_FINISHED_JOBS.REQUEST, clearFinishedJobs),
    takeLatest(actions.CLEAR_FAILED_JOBS.REQUEST, clearFailedJobs),
  ])
}

